// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_center_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { MessageSettings, MessageTranslation } from "./message_preferences_pb";
import { file_message_preferences } from "./message_preferences_pb";
import type { MessageRule } from "./message_rule_pb";
import { file_message_rule } from "./message_rule_pb";
import type { MessageType } from "./message_type_pb";
import { file_message_type } from "./message_type_pb";
import type { EventType } from "./event_type_pb";
import { file_event_type } from "./event_type_pb";
import type { Campaign } from "./campaign_pb";
import { file_campaign } from "./campaign_pb";
import type { ReservationService } from "./reservation_service_pb";
import { file_reservation_service } from "./reservation_service_pb";
import type { Tab } from "./tab_pb";
import { file_tab } from "./tab_pb";
import type { Handlebar } from "./handlebar_pb";
import { file_handlebar } from "./handlebar_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_center_service.proto.
 */
export const file_message_center_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_empty, file_message_preferences, file_message_rule, file_message_type, file_event_type, file_campaign, file_reservation_service, file_tab, file_handlebar]);

/**
 * preferences
 *
 * @generated from message grpc.api.v1.MessageCenterResponse
 */
export type MessageCenterResponse = Message<"grpc.api.v1.MessageCenterResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];

  /**
   * @generated from field: repeated grpc.api.v1.MessageType messageTypes = 3;
   */
  messageTypes: MessageType[];

  /**
   * @generated from field: repeated grpc.api.v1.EventType eventTypes = 4;
   */
  eventTypes: EventType[];

  /**
   * @generated from field: repeated grpc.api.v1.Campaign campaigns = 5;
   */
  campaigns: Campaign[];

  /**
   * @generated from field: repeated grpc.api.v1.ReservationService services = 6;
   */
  services: ReservationService[];

  /**
   * @generated from field: repeated grpc.api.v1.Tab tabs = 7;
   */
  tabs: Tab[];

  /**
   * @generated from field: repeated grpc.api.v1.Handlebar handlebars = 8;
   */
  handlebars: Handlebar[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterResponse.
 * Use `create(MessageCenterResponseSchema)` to create a new message.
 */
export const MessageCenterResponseSchema: GenMessage<MessageCenterResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 0);

/**
 * @generated from message grpc.api.v1.MessageCenterPreferencesRequest
 */
export type MessageCenterPreferencesRequest = Message<"grpc.api.v1.MessageCenterPreferencesRequest"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterPreferencesRequest.
 * Use `create(MessageCenterPreferencesRequestSchema)` to create a new message.
 */
export const MessageCenterPreferencesRequestSchema: GenMessage<MessageCenterPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 1);

/**
 * @generated from message grpc.api.v1.MessageCenterPreferencesResponse
 */
export type MessageCenterPreferencesResponse = Message<"grpc.api.v1.MessageCenterPreferencesResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageSettings settings = 1;
   */
  settings?: MessageSettings | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.MessageTranslation translations = 2;
   */
  translations: MessageTranslation[];
};

/**
 * Describes the message grpc.api.v1.MessageCenterPreferencesResponse.
 * Use `create(MessageCenterPreferencesResponseSchema)` to create a new message.
 */
export const MessageCenterPreferencesResponseSchema: GenMessage<MessageCenterPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 2);

/**
 * rules
 *
 * @generated from message grpc.api.v1.MessageRuleIdRequest
 */
export type MessageRuleIdRequest = Message<"grpc.api.v1.MessageRuleIdRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.MessageRuleIdRequest.
 * Use `create(MessageRuleIdRequestSchema)` to create a new message.
 */
export const MessageRuleIdRequestSchema: GenMessage<MessageRuleIdRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 3);

/**
 * @generated from message grpc.api.v1.MessageRuleRequest
 */
export type MessageRuleRequest = Message<"grpc.api.v1.MessageRuleRequest"> & {
  /**
   * @generated from field: grpc.api.v1.MessageRule rule = 1;
   */
  rule?: MessageRule | undefined;
};

/**
 * Describes the message grpc.api.v1.MessageRuleRequest.
 * Use `create(MessageRuleRequestSchema)` to create a new message.
 */
export const MessageRuleRequestSchema: GenMessage<MessageRuleRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 4);

/**
 * @generated from message grpc.api.v1.MessageRuleResponse
 */
export type MessageRuleResponse = Message<"grpc.api.v1.MessageRuleResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MessageRule rule = 1;
   */
  rule?: MessageRule | undefined;
};

/**
 * Describes the message grpc.api.v1.MessageRuleResponse.
 * Use `create(MessageRuleResponseSchema)` to create a new message.
 */
export const MessageRuleResponseSchema: GenMessage<MessageRuleResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 5);

/**
 * locale priority mode onboarding action: enter the draft step (step 1), promote to
 * locale_priority_mode (step 2), or cancel the draft step
 *
 * @generated from message grpc.api.v1.SetLocalePriorityModeRequest
 */
export type SetLocalePriorityModeRequest = Message<"grpc.api.v1.SetLocalePriorityModeRequest"> & {
  /**
   * @generated from field: grpc.api.v1.SetLocalePriorityModeRequest.Action action = 1;
   */
  action: SetLocalePriorityModeRequest_Action;
};

/**
 * Describes the message grpc.api.v1.SetLocalePriorityModeRequest.
 * Use `create(SetLocalePriorityModeRequestSchema)` to create a new message.
 */
export const SetLocalePriorityModeRequestSchema: GenMessage<SetLocalePriorityModeRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 6);

/**
 * @generated from enum grpc.api.v1.SetLocalePriorityModeRequest.Action
 */
export enum SetLocalePriorityModeRequest_Action {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTER_DRAFT = 1;
   */
  ENTER_DRAFT = 1,

  /**
   * @generated from enum value: PROMOTE_DRAFT = 2;
   */
  PROMOTE_DRAFT = 2,

  /**
   * @generated from enum value: CANCEL_DRAFT = 3;
   */
  CANCEL_DRAFT = 3,

  /**
   * TESTING ONLY: inverse of PROMOTE_DRAFT - move the promoted templates back to the
   * draft table, restore the parked obsolete templates to live, and return the account
   * to the draft step (locale_priority_draft). From there: PROMOTE again or CANCEL.
   *
   * @generated from enum value: REVERT_TO_DRAFT = 4;
   */
  REVERT_TO_DRAFT = 4,
}

/**
 * Describes the enum grpc.api.v1.SetLocalePriorityModeRequest.Action.
 */
export const SetLocalePriorityModeRequest_ActionSchema: GenEnum<SetLocalePriorityModeRequest_Action> = /*@__PURE__*/
  enumDesc(file_message_center_service, 6, 0);

/**
 * template preview from synthetic data: render arbitrary template content (subject/body)
 * as the given message type + event type + locale, using fabricated reservation/contact/
 * service/giftcard data + the account's real branding & settings. No saved template is
 * involved; the layout is derived server-side (email only) exactly like the save path, so
 * the preview matches what the template would render with once saved. subject applies to
 * email only. Content is client-owned (the editor always holds it), so unsaved edits and
 * brand-new localizations preview identically to saved ones.
 *
 * @generated from message grpc.api.v1.PreviewTemplateRequest
 */
export type PreviewTemplateRequest = Message<"grpc.api.v1.PreviewTemplateRequest"> & {
  /**
   * @generated from field: int32 message_type_id = 1;
   */
  messageTypeId: number;

  /**
   * @generated from field: int32 event_type_id = 2;
   */
  eventTypeId: number;

  /**
   * @generated from field: string locale = 3;
   */
  locale: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string subject = 5;
   */
  subject: string;

  /**
   * rule's service filter; 0 = server picks a sample service
   *
   * @generated from field: int32 service_id = 6;
   */
  serviceId: number;
};

/**
 * Describes the message grpc.api.v1.PreviewTemplateRequest.
 * Use `create(PreviewTemplateRequestSchema)` to create a new message.
 */
export const PreviewTemplateRequestSchema: GenMessage<PreviewTemplateRequest> = /*@__PURE__*/
  messageDesc(file_message_center_service, 7);

/**
 * @generated from message grpc.api.v1.PreviewTemplateResponse
 */
export type PreviewTemplateResponse = Message<"grpc.api.v1.PreviewTemplateResponse"> & {
  /**
   * @generated from field: string subject = 1;
   */
  subject: string;

  /**
   * @generated from field: string plaintext = 2;
   */
  plaintext: string;

  /**
   * @generated from field: string html = 3;
   */
  html: string;
};

/**
 * Describes the message grpc.api.v1.PreviewTemplateResponse.
 * Use `create(PreviewTemplateResponseSchema)` to create a new message.
 */
export const PreviewTemplateResponseSchema: GenMessage<PreviewTemplateResponse> = /*@__PURE__*/
  messageDesc(file_message_center_service, 8);

/**
 * @generated from service grpc.api.v1.MessageCenterService
 */
export const MessageCenterService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.getMessageCenter
   */
  getMessageCenter: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof MessageCenterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.listMessageRules
   */
  listMessageRules: {
    methodKind: "server_streaming";
    input: typeof EmptyRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessagePreferences
   */
  updateMessagePreferences: {
    methodKind: "unary";
    input: typeof MessageCenterPreferencesRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * locale priority mode onboarding: enter draft / promote / cancel via the action field
   *
   * @generated from rpc grpc.api.v1.MessageCenterService.setLocalePriorityMode
   */
  setLocalePriorityMode: {
    methodKind: "unary";
    input: typeof SetLocalePriorityModeRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessageLanguagePreferences
   */
  updateMessageLanguagePreferences: {
    methodKind: "unary";
    input: typeof MessageCenterPreferencesRequestSchema;
    output: typeof MessageCenterPreferencesResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.getMessageRule
   */
  getMessageRule: {
    methodKind: "unary";
    input: typeof MessageRuleIdRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MessageCenterService.updateMessageRule
   */
  updateMessageRule: {
    methodKind: "unary";
    input: typeof MessageRuleRequestSchema;
    output: typeof MessageRuleResponseSchema;
  },
  /**
   * render a template localization from synthetic data (email/sms/push preview)
   *
   * @generated from rpc grpc.api.v1.MessageCenterService.previewTemplate
   */
  previewTemplate: {
    methodKind: "unary";
    input: typeof PreviewTemplateRequestSchema;
    output: typeof PreviewTemplateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_message_center_service, 0);

